import { Component, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { MenuStore } from '../../../menus/service/menu.store';
import { SummaryRecordTypeEnum } from '../../models/summary-record-type.enum';
import { RouteUtils } from '../../utils/route-utils';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationStore } from '../../../permission/services/authentication.store';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { EventUtils } from '../../utils/event-utils';

@Component({
  selector: 'pioneer-overview-page',
  templateUrl: './overview-page.component.html'
})
export class OverviewPageComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  public headerRecordType: SummaryRecordTypeEnum;

  constructor(private eventStore: EventStore,
              private menuStore: MenuStore,
              private route: ActivatedRoute,
              private authenticationSore: AuthenticationStore,
              private flashMessagesService: FlashMessagesService) {

  }

  ngOnInit() {
    this.eventStore.selectedEvent.subscribe(event => this.onyxEvent = event);
    if (this.onyxEvent) {
      this.menuStore.setPageHeader(this.onyxEvent.name, this.onyxEvent.eventProperty.subscriber);
    }

    // If the event property is subscribed, reservations are retrieved to build the overview.
    // Otherwise, RSVPs are
    if (this.onyxEvent && this.onyxEvent.eventProperty.subscriber) {
      this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;
    } else {
      this.headerRecordType = SummaryRecordTypeEnum.RSVP;
    }

    // toggle page to editable if the URL ends with "edit" (it will default to read only)
    // otherwise, check if we need to show a warning flash message when in view modeFD
    RouteUtils.getLastUrlSegment(this.route)
      .subscribe(lastSegment => {
        if (this.authenticationSore.hasPermission('EditEvent') && !this.isEventValid()) {
          this.flashMessagesService.warn('EVENT.EVENT_MISSING_INFO',
            null,
            { hrefValue: `/#/event/${this.onyxEvent.eventId}/summary/edit` });
        }
      });

  }

  isEventValid(): boolean {
    return EventUtils.isEventValid(this.onyxEvent);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/overview/overview-page/overview-page.component.ts